import { render, staticRenderFns } from "./AppointmentRecord.vue?vue&type=template&id=4f23e73a"
import script from "./AppointmentRecord.vue?vue&type=script&lang=js"
export * from "./AppointmentRecord.vue?vue&type=script&lang=js"
import style0 from "./AppointmentRecord.vue?vue&type=style&index=0&id=4f23e73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports